





















  import { ClaimEnum } from '@/services/ClaimEnum';
  import { General } from '@/services/General';
  import { Component, Vue } from 'vue-property-decorator';
  import PendingContractsWidget from '../Net20/widgets/PendingContractsWidget.vue';
  import PendingPlansWidget from '../Ppe/widgets/PendingPlansWidget.vue';
  import ExpiredContractsWidget from '../Net20/widgets/ExpiredContractsWidget.vue';
  import { DropDownItem } from '@/services/DropDownItem';
  import axios from 'axios';

  @Component({
      components: {
          PendingContractsWidget,
          PendingPlansWidget,
          ExpiredContractsWidget
      }
  })
  export default class PendingActivitiesWidget extends Vue {
      loading: boolean = false;
      showPendingActivities: boolean = false;

      pendingContracts: number = 0;
      showPendingContracts: boolean = false;

      expiredContracts: number = 0;
      showExpiredContracts: boolean = false;

      pendingPlans: number = 0;
      showPendingPlans: boolean = false;

      dropDownSalesman: any = new Array();
      isSalesman: boolean = false;

      hasNet20ManagerClaim: boolean = false;
      hasPpeManagerClaim: boolean = false;

      async mounted() {
          this.hasNet20ManagerClaim = this.checkNet20ManagerClaim();
          this.hasPpeManagerClaim = this.checkPpeManagerClaim();

          if(this.hasNet20ManagerClaim) {
              this.dropDownSalesman = await this.getDropdownSalesman();
              this.setIsSalesman();
          }
      }

      pendingContractsSync(pendingContracts: number) {
          this.pendingContracts = pendingContracts;
          this.setPendingActivitiesWidgetVisibilty();
          
          this.showPendingContracts = this.setWidgetVisibility(pendingContracts);
      }

      expiredContractsSync(expiredContracts: number) {
          this.expiredContracts = expiredContracts;
          this.setPendingActivitiesWidgetVisibilty();
          
          this.showExpiredContracts = this.setWidgetVisibility(expiredContracts);
      }

      pendingPlansSync(pendingPlans: number) {
          this.pendingPlans = pendingPlans;
          this.setPendingActivitiesWidgetVisibilty();
          
          this.showPendingPlans = this.setWidgetVisibility(pendingPlans);
      }

      setPendingActivitiesWidgetVisibilty() {
          if(this.pendingContracts > 0 || this.pendingPlans > 0 || this.expiredContracts > 0)
              this.showPendingActivities = true;
          else
              this.showPendingActivities = false;
      }

      checkNet20ManagerClaim() {
          return General.CheckAuthorization(ClaimEnum.CanManageNet20);
      }

      checkPpeManagerClaim() {
          return General.CheckAuthorization(ClaimEnum.CanManagePpe);
      }

      setWidgetVisibility(totalRecords: number) {
          if(totalRecords > 0)
              return true;
          else
              return false;
      }

      async getDropdownSalesman(): Promise<Array<any>> {
          try{
              let user: DropDownItem = new DropDownItem();
              let usersList: DropDownItem[] = [];

              let response = await axios.get<any[]>(
                  General.GetApiUrl('/api/net20/GetSalesmanForUser'),{
                  responseType: "json",
                  withCredentials: true
              });
              if(response.data) {
                  response.data.forEach( element => {
                      user = new DropDownItem();
                      user.idDropDownItem = element.idUser;
                      user.itemText = element.username;

                      usersList.push(user);
                  });
                  return General.SetOptionsDropDown(usersList);
              }
          } catch(ex) {
              General.HandleError(ex, this);
              return null;
          }
      }

      async setIsSalesman() {
          var username = this.$store.state.user.Username;
          if (this.$store.state.impersonatedBy != null)
              username = this.$store.state.userToImpersonate;
          
          var checkIndex = this.dropDownSalesman.findIndex(s => s.text.toLowerCase() === username.toLowerCase());
          if(checkIndex >= 0) {
              this.isSalesman = true;
          } else {
              this.isSalesman = false;
          }
      }
}
